export const FEATURE_FLAG = {
  DIRECT_CHANNEL_WIRE: 'useDirectChannelWire',
  CC_BOOKING_OWNER: 'ccBookingOwner',
  REST_OF_WORLD: 'showRestOfWorld',
  PAYMENT_RECEIPT_PREFER_LIGHT_COLORS: 'paymentReceiptPreferLightColors',
  MARGIN_PROTECTION: 'marginProtection', // isMarginProtectionEnabled
  // email specific
  EMAILS_PAYMENT_CSV_ATTACH: 'paymentCsvAttach',
  EMAILS_SEND_INVOICE_UPDATES: 'emailSendInvoiceUpdates',
  JACADA_ENHANCEMENTS: 'jacadaEnhancements',
  RACK_PLUS: 'useRackPlus',
  NEW_PAYMENT_FLOW: 'newPaymentFlow',
  SHARE_LINKS_V2: 'shareLinksV2',
  AGENT_BOOKING_DOCUMENT: 'agentBookingDocument',
  DISABLE_ESCROW_FEES: 'disableEscrowFees',
  DISABLE_TRANSFER_DISCOUNTS: 'disableTransferDiscounts',
  ALLOW_CHAT: 'allowChat',
  FLYWIRE_PAYMENTS: 'flywirePayments',
  FLYWIRE_DIRECT_DEBIT: 'flywireDirectDebit',
  UPLIFT_PAYMENTS: 'upliftPayments',
  ACCOMMODATION_PROFILES: 'accommodationProfiles',
  ENABLE_SIGNUP: 'enableSignup',
  NEW_PORTAL: 'newPortal',
};
